import { api, setCurrentOrgId } from "./api/client";
import { liveEvents } from "./api/events";
import { apiKey } from "./api/hooks";
import { queryClient } from "./api/query-client";
import { storage } from "./utils";
import type { Me } from "./types";

/** Session lives in an httpOnly cookie set by the API: nothing auth-related is stored client-side. */
/** Onboarding finished or skipped for this org (read by the /_app guard; written by the wizard). */
export const onboardingDoneKey = (orgId: string) => `malfak.onboarding.skipped.${orgId}`;

export function adoptSession(me: Me) {
  const remembered = storage.get("malfak.org");
  const orgId = me.orgs.some((o) => o.id === remembered) ? remembered : me.currentOrgId;
  setCurrentOrgId(orgId);
  queryClient.setQueryData(apiKey("me"), me);
  return orgId;
}

export async function signOut() {
  try {
    await api("logout", { body: {} });
  } finally {
    liveEvents.disconnect();
    setCurrentOrgId(null);
    queryClient.clear();
  }
}

export function switchOrg(orgId: string) {
  storage.set("malfak.org", orgId);
  setCurrentOrgId(orgId);
  liveEvents.disconnect();
  void queryClient.resetQueries();
  void liveEvents.connect();
}

/** Malfak staff (platform admins) see the /admin area. Org roles (owner/admin/…) don't grant it. */
export function isPlatformAdmin(me: Me | null | undefined): boolean {
  return me?.user.platformRole === "platform_admin";
}
